export function getPrefix() {
    const data = window._data || {};

    return (data.config && data.config.prefix) || '';
}
